import { useEffect } from 'react'
import { useThemeStore } from '../store/theme'

function rings(stroke: string): string {
  return (
    `<ellipse cx="50" cy="50" rx="44" ry="26" fill="none" stroke="${stroke}" stroke-width="3"/>` +
    `<ellipse cx="50" cy="54" rx="34" ry="19" fill="none" stroke="${stroke}" stroke-width="2.5" opacity="0.72"/>` +
    `<ellipse cx="50" cy="57" rx="24" ry="13" fill="none" stroke="${stroke}" stroke-width="2" opacity="0.48"/>` +
    `<ellipse cx="50" cy="60" rx="14" ry="7.5" fill="none" stroke="${stroke}" stroke-width="1.5" opacity="0.28"/>` +
    `<ellipse cx="50" cy="62" rx="5.5" ry="2.5" fill="none" stroke="${stroke}" stroke-width="1" opacity="0.14"/>`
  )
}

function buildFaviconSvg(shadow: string, ring: string): string {
  return (
    `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">` +
    // shadow rings offset down-right and dimmed sit behind the main ring color
    `<g transform="translate(2.5 2.5)" opacity="0.5">${rings(shadow)}</g>` +
    `<g>${rings(ring)}</g>` +
    `</svg>`
  )
}

export function useFaviconSync() {
  const userTheme = useThemeStore((s) => s.userTheme)

  useEffect(() => {
    const root = document.documentElement
    const computed = getComputedStyle(root)
    const color1 = userTheme?.color1 ?? (computed.getPropertyValue('--color-1').trim() || '#c0392b')
    const color2 = userTheme?.color2 ?? (computed.getPropertyValue('--color-2').trim() || '#2980b9')

    // color1 rings over a color2 drop shadow
    const href = `data:image/svg+xml,${encodeURIComponent(buildFaviconSvg(color2, color1))}`
    const link = document.querySelector<HTMLLinkElement>('link[rel="icon"]')
    if (link) link.href = href
  }, [userTheme])
}
